import { formatNumberForTable } from "@/Utils/formatFunctions";
import { PresetKey } from "@/components/v2/DatePicker/constants";

import { twMerge } from "tailwind-merge";

const DOWN_TREND_ARROW = "↓";
const UP_TREND_ARROW = "↑";

export const comparisonKeys: { [k: string]: string } = {
  [PresetKey.Last7]: "datePicker:comparisonLast7Days",
  [PresetKey.Last30]: "datePicker:comparisonLast30Days",
  [PresetKey.Last90]: "datePicker:comparisonLast90Days",
  [PresetKey.Last12m]: "datePicker:comparisonLast12Months",
  [PresetKey.PrevMonth]: "datePicker:comparisonPrevMonth",
  [PresetKey.PrevQuarter]: "datePicker:comparisonPrevQuarter",
  [PresetKey.PrevYear]: "datePicker:comparisonPrevYear",
};

export const getKpiValue = (value?: number) => {
  if (!value) return 0;

  return formatNumberForTable(value, {
    numDecimals: 0,
  });
};

export const getPercentage = (value?: number, total?: number) => {
  if (!value || !total) return 0;
  return (value * 100) / total;
};

type Props = {
  hasNoComparisonData: boolean;
  currentValue: number;
  comparisonValue: number;
  comparisonKey: string;
  comparePercentages?: boolean;
  higherBetter?: boolean;
  differenceSuffix?: string;
};

const getBottomTextValues = ({
  currentValue,
  comparisonValue,
  comparisonKey,
  comparePercentages = false,
  higherBetter = false,
  differenceSuffix = "",
}: Props) => {
  const difference = currentValue - comparisonValue;

  const differenceInPercentage = comparisonValue
    ? (difference * 100) / comparisonValue
    : 100;

  let trend = "";
  if (difference === 0) {
    trend = "";
  } else if (higherBetter) {
    trend = difference > 0 ? UP_TREND_ARROW : DOWN_TREND_ARROW;
  } else {
    trend = difference < 0 ? DOWN_TREND_ARROW : UP_TREND_ARROW;
  }

  const absoluteValue = Math.abs(
    comparePercentages ? differenceInPercentage : difference,
  );
  const differenceValue =
    +absoluteValue.toFixed(0) === 0
      ? "-"
      : formatNumberForTable(absoluteValue, {
          numDecimals: 0,
        });

  return {
    isPositive: higherBetter ? difference > 0 : difference < 0,
    bottomText: `${trend} ${differenceValue}${differenceSuffix} ${comparisonKey}`,
  };
};

export const BottomTextView = ({
  isPositive,
  bottomText,
}: {
  isPositive: boolean;
  bottomText: string;
}) => (
  <div
    className={twMerge(
      "mt-1.5 text-[clamp(9.5px,0.78vw,12.5px)]",
      isPositive ? "text-carrot-green" : "text-grey6",
    )}
  >
    {bottomText}
  </div>
);

export const getBottomTextView = (props: Props) => {
  if (props.hasNoComparisonData) {
    return "";
  }

  const { isPositive, bottomText } = getBottomTextValues(props);

  return <BottomTextView isPositive={isPositive} bottomText={bottomText} />;
};
